<template>
  <div>页面跳转中...</div>
</template>

<script>
export default {
  name: "Jump",
  data() {
    return {
      liveroomId: this.$route.params.id || undefined
    };
  },
  created() {
    this.$router.push({
      path: "/",
      query: {
        liveroom_id: this.liveroomId
      }
    });
  }
};
</script>

<style scoped></style>
